export { setupWordpressSupport as wordpress } from './wordpress';
export function publishSmartfireInScope(API) {
  window.smartfire = Object.assign(window.smartfire || {}, API);
}
